/**
 * Configuration for the app.
 */
const jobiqoAppConfig = require('./../../src/jobiqo/config/app');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const defaultLocale = 'en';
const defaultRegion = 'eu';
const locales = ['en'];

module.exports = mergeDeepRight(jobiqoAppConfig, {
  public: {
    TURBOPACK_BUILD: true,
    EURO_VAT_SYSTEM: false,
    SITENAME: 'Delmarva Life Jobs',
    SITE_DESCRIPTION:
      'Get career and job search advice, or search over 2 million jobs on the largest job network',
    DEFAULT_LOCALE: defaultLocale,
    DEFAULT_REGION: defaultRegion,
    LOCALES: locales,
    SOCIAL_LINKS: {
      facebook: 'https://www.facebook.com/WBOCTV16',
      twitter: 'https://twitter.com/wbo',
      instagram: 'https://www.instagram.com/wboc16',
      linkedin: 'https://www.linkedin.com/company/wboc-tv',
      youtube: 'https://www.youtube.com/c/wboc',
    },
    ASSETS: {
      logo: '/static/delmarvalife/logo.png',
      faviconsPath: '/static/delmarvalife',
    },
    OG_IMAGE: '/static/delmarvalife/logo.png',
    AUTOCOMPLETE_WIDGET_OPTIONS: {
      country: ['us', 'ca'],
    },
    THEME: {
      colors: {
        primary: '#2e539c',
        secondary: '#ffffff',
      },
    },

    LINKEDIN_OAUTH_FEATURE_ACTIVE: true,
    FACEBOOK_OAUTH_FEATURE_ACTIVE: true,
    GOOGLE_OAUTH_FEATURE_ACTIVE: true,
    GA4_MEASUREMENT_IDS: ['G-NRSJB1NW24', 'G-04SBN34ERZ'],
    BLOG_FEATURE_ACTIVE: true,
  },
});
